import { PermissionModel } from '@root/app/authorization/models/auth.model';
import { XEMEX_OID } from '@core/constants/company.constant';
import {
  UserProfile,
  getUserFeaturePermissions,
  getUserInitialPartner,
} from '@core/models/user.model';

// Installations are shown to Xemex users only, on top of the feature: prd grants
// view_installations to every partner role that can see locations. The Xemex test is the one
// xemexGuard and the sidebar's `xemexOnly` entries apply (the initial partner, not the active
// one), so an element never links to a page its route refuses.
// Until the profile and the permissions have loaded, canViewInstallations says no to everyone,
// so a "no" only means the user may not see installations once this holds.
export function installationAccessKnown(
  user: UserProfile | undefined,
  permissions: PermissionModel[] | undefined,
): boolean {
  return permissions !== undefined && (user?.partners?.length ?? 0) > 0;
}

export function canUseInstallationFeature(
  user: UserProfile | undefined,
  permissions: PermissionModel[] | undefined,
  feature: string,
): boolean {
  return (
    getUserInitialPartner(user)?.partnerOid === XEMEX_OID &&
    getUserFeaturePermissions(user, permissions, XEMEX_OID).includes(feature)
  );
}

export function canViewInstallations(
  user: UserProfile | undefined,
  permissions: PermissionModel[] | undefined,
): boolean {
  return canUseInstallationFeature(user, permissions, 'view_installations');
}
